import * as moment from 'moment'
import * as React from 'react'
import { Button } from 'react-bootstrap'
import Form, { IChangeEvent, ISubmitEvent } from 'react-jsonschema-form'
import ActionsLocalService from '../Services/ActionsLocalService'
import HttpActionsService from '../Services/HttpActionsService'
import LocalizationStore from '../Stores/LocalizationStore'
import UserStore from '../Stores/UserStore'
import { Questionnaire, QuestionnaireStatus } from './Questionnaire'

export class CourtDecision {
    id: string
    creditId: string
    courtDecisionDistrict: string
    courtDecisionDate: string
    courtDecisionAmount?: number
}

export function getCourtDecisionFormScheme(courtDecision?: CourtDecision): any {
    const ls = LocalizationStore.getInstance()
    return {
        title: ls.t!('courtDecision'),
        type: 'object',
        required: [
            'courtDecisionDistrict',
            'creditId'
        ],
        properties: {
            creditId: {
                type: 'string',
            },
            courtDecisionDistrict: {
                title: ls.t!('courtDecisionDistrict'),
                type: 'string',
                enum: [
                    'Abşeron',
                    'Ağdam',
                    'Ağdaş',
                    'Ağstafa',
                    'Ağsu',
                    'Babək',
                    'Balakən',
                    'Bərdə',
                    'Beyləqan',
                    'Biləsuvar',
                    'Binəqədi',
                    'Cəbrayıl',
                    'Cəlilabad',
                    'Culfa',
                    'Daşkəsən',
                    'Fizuli',
                    'Gədəbəy',
                    'Gəncə',
                    'Goranboy',
                    'Göyçay',
                    'Göygöl',
                    'Hacıqabul',
                    'İmişli',
                    'ismayıllı',
                    'Kəlbəcər',
                    'Kürdəmir',
                    'Laçın',
                    'Lənkəran',
                    'Lerik',
                    'Masallı',
                    'Mingəçevir',
                    'Naftalan',
                    'Naxçıvan',
                    'Neftçala',
                    'Nərimanov',
                    'Nəsimi',
                    'Nizami',
                    'Oğuz',
                    'Ordubad',
                    'Pirallahı',
                    'Qaradağ',
                    'Qax',
                    'Qəbələ',
                    'Qobustan',
                    'Quba',
                    'Qubadlı',
                    'Qusar',
                    'Saatlı',
                    'Sabirabad',
                    'Şabran',
                    'Sabunçu',
                    'Şamaxı',
                    'Samux',
                    'Səbail',
                    'Sədərək',
                    'Şəki',
                    'Səlyan',
                    'Şəmkir',
                    'Şərur',
                    'Şirvan',
                    'Siyəzən',
                    'Sumqayıt',
                    'Suraxanı',
                    'Şuşa',
                    'Tərtər',
                    'Tovuz',
                    'Ucar',
                    'Xaçmaz',
                    'Xətai',
                    'Xəzər',
                    'Xızı',
                    'Xocalı',
                    'Xocavənd',
                    'Yardımlı',
                    'Yasamal',
                    'Yevlax',
                    'Zaqatala',
                    'Zəngilan',
                    'Qazax',
                    'Ağcabədi',
                    'Zərdab'
                ]
            },
            courtDecisionDate: {
                title: ls.t!('courtDecisionDate'),
                type: 'string',
                format: 'date'
            },
            courtDecisionAmount: {
                title: ls.t!('courtDecisionAmount'),
                type: 'number',
                minimum: 0,
                default: 0
            }
        }
    }
}

export function getCourtDecisionFormUISchema(isReadonly: boolean) {

    return {
        creditId: {
            'ui:readonly': isReadonly,
            'ui:widget': 'hidden'
        },
        courtDecisionDistrict: {
            'ui:readonly': isReadonly
        },
        courtDecisionDate: {
            'ui:readonly': isReadonly
        },
        courtDecisionAmount: {
            'ui:readonly': isReadonly
        }
    }
}

export function onChange(e: IChangeEvent<CourtDecision>) {
    if (e.formData) {
        ActionsLocalService.getInstance().updateCourtDecisionInQ(e.formData)
    }
}

export function onSubmit(e: ISubmitEvent<CourtDecision>) {
    HttpActionsService.getInstance()
        .updateCourtDecision(e.formData)
}

export function checkCanSave(questionnaire: Questionnaire) {
    const userStore = UserStore.getInstance()

    return (
        questionnaire.id &&
        questionnaire.status &&
        questionnaire.status !== 0 &&
        questionnaire.status !== QuestionnaireStatus.Canceled &&
        (
            userStore.checkAdmin
            || userStore.checkSuperAdmin
            || userStore.checkCollectionGroupAdministrator
            || userStore.checkLawyer
        )
    )
}

export function getCourtDecisionForm(questionnaire: Questionnaire) {

    const userStore = UserStore.getInstance()

    if (!questionnaire.credit.courtDecision &&
        !(
            userStore.checkCollectionGroupAdministrator ||
            userStore.checkAdmin ||
            userStore.checkSuperAdmin ||
            userStore.checkLawyer
        )
    ) {
        return
    }

    const ls = LocalizationStore.getInstance()
    let isReadonly = !checkCanSave(questionnaire)

    if (!questionnaire.credit.courtDecision) {
        questionnaire.credit.courtDecision = new CourtDecision()
    }
    questionnaire.credit.courtDecision!.creditId = questionnaire.credit.id

    if (questionnaire!.credit!.courtDecision!.courtDecisionDate!) {
        questionnaire!.credit!.courtDecision!.courtDecisionDate =
            moment(questionnaire!.credit!.courtDecision!.courtDecisionDate!)
                .format('YYYY-MM-DD')
    }

    return (
        <Form
            schema={getCourtDecisionFormScheme(questionnaire!.credit!.courtDecision)}
            uiSchema={getCourtDecisionFormUISchema(isReadonly && !!questionnaire.id)}
            onSubmit={onSubmit}
            formData={questionnaire!.credit!.courtDecision}
            onChange={() => onChange}
        >
            <div
                className="questionnaireBtns"
                hidden={isReadonly}
            >
                <Button
                    className="w-100"
                    type="submit"
                >
                    {ls!.t!('Save')}
                </Button>
            </div>
        </Form >
    )
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Model/CourtDecision.tsx